import React from 'react'
import { connect } from 'react-redux'
import { setSDK, setLang } from '../actions/common'

const timer = 1000

/**
 * @return {null}
 */
class SKInitializer extends React.Component {
  waitSK() {
    const { setSDK, SDK } = this.props
    if (typeof SK !== 'undefined' && SDK !== 'initialized') {
      this.checkLang()
      // this.auth()
      setSDK('initialized')
    } else {
      setTimeout(() => this.waitSK(), timer)
    }
  }

  checkLang() {
    const { setSDK, setLang, language } = this.props

    if (SK.getLang() === 'en') {
      setLang('en')
    }
    SK.on('changeLang', () => {
      const lang = typeof SK !== 'undefined' ? SK.getLang() : 'ru'
      if (lang !== language) {
        setLang(lang)
        setSDK('')
      }
    })
  }

  // auth() {
  //   const { getFilters, clearFiltersReset, showNextPage } = this.props
  //   SK.on('login', () => {
  //     checkAuth()
  //     getFilters()
  //     clearFiltersReset()
  //     showNextPage()
  //   })
  // }

  render() {
    this.waitSK()
    return null
  }
}

const mapStateToProps = state => ({
  SDK: state.common.SDK,
  language: state.common.language,
})

const mapDispatchToProps = {
  setSDK,
  setLang,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SKInitializer)
